export default __webpack_public_path__ + "static/media/menu.c237674d.svg";